import React, { useEffect, useState } from 'react';
import { SignUpSteps } from './SignUpNew';
import styles from './New.module.scss';
import { ReactComponent as PhoneIcon } from 'images/new-icons/Phone.svg';
import Button from 'components/shared/Button';
import { StringConstant } from 'utils/Constants';
import supabase from 'sdk/api';
import SocialLinks from '../../SocialLinks';
import { useTranslation } from 'react-i18next';

type Props = {
  phone: string;
  setPhone: (phone: string) => void;
  setStep: (step: SignUpSteps) => void;
};

const Phone = ({ phone, setPhone, setStep }: Props) => {
  const [phoneError, setPhoneError] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { t } = useTranslation() as any;
  const formatPhoneNumber = (value: string) => {
    const digits = value.replace(/\D/g, '');
    let displayDigits = '';
    if (digits.startsWith('966')) {
      displayDigits = digits.slice(3, 12);
    } else {
      displayDigits = digits.slice(0, 9);
    }

    return '+966 ' + displayDigits;
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let digits = e.target.value.replace(/\D/g, '');
    
    if (digits.startsWith('966')) {
      digits = digits.slice(3);
    }
    
    const userDigits = digits.slice(0, 9);
    setPhone('966' + userDigits);
  };

  const handleSendCode = async () => {
    setIsLoading(true);
    try {
      const { data: user, error: userError } = await supabase
        .from('user_profiles')
        .select('*')
        .eq('phone', phone);

      if (user?.length) {
        setPhoneError(StringConstant.SIGN_UP_ALREADY_REGISTERED);
        return;
      }

      setPhoneError('');

      const ANON_KEY =  process.env.REACT_APP_SUPABASE_ANON_KEY;


      await fetch('https://gibnkggiuxphkienkxwf.supabase.co/functions/v1/auth', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${ANON_KEY}`,
        },
        body: JSON.stringify({
          phone,
        }),
      });
  

      setStep(SignUpSteps.Code);
    } catch (error) {
      console.error('Error checking account:', error);
      setPhoneError('Error checking phone number');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (phone) {
      setPhoneError('');
    }
  }, [phone]);

  return (
    <div className={styles.email}>
      <div className={styles.step_header}>{t('step_two_phone')}</div>
      <div className={styles.email_fields}>
        <div
          className={styles.email_fields_field}
          style={{
            border: phoneError ? '1px solid #FF3B30' : '1px solid #01010180',
          }}
        >
          <PhoneIcon />
          <input
            type="text"
            placeholder="Phone number"
            value={formatPhoneNumber(phone)}
            onChange={handlePhoneChange}
          />
        </div>
        {phoneError && <div className={styles.error}>{phoneError}</div>}
      </div>
      <Button 
        wide 
        darkGreen 
        onClick={handleSendCode} 
        loading={isLoading}
        disabled={phone.length < 12}
      >
        {t('send_code')}
      </Button>
      <div>{t('or')}</div>
      <SocialLinks />
    </div>
  );
};

export default Phone;
